import { BookmarkFilledIcon, BookmarkIcon } from '@radix-ui/react-icons';
import { IconButton, IconProps } from '@radix-ui/themes';
import React, { ForwardRefExoticComponent, RefAttributes } from 'react';

type Bookmark = 'true' | 'false';

const ICON_FOR_BOOKMARK: {
    [key in Bookmark]: ForwardRefExoticComponent<
        IconProps & RefAttributes<SVGSVGElement>
    >;
} = {
    true: BookmarkFilledIcon,
    false: BookmarkIcon,
};

interface BookmarkSwitchProps {
    onChange?: (isBookmarked: boolean) => void;
}

export const BookmarkSwitch = ({ onChange }: BookmarkSwitchProps) => {
    const [isBookmarked, setIsBookmarked] = React.useState(false);
    const Icon = ICON_FOR_BOOKMARK[String(isBookmarked) as Bookmark];

    const handleOnClick = (event: React.MouseEvent<SVGSVGElement>) => {
        event.stopPropagation();
        setIsBookmarked((old) => !old);
        onChange?.(!isBookmarked);
    };

    return (
        <IconButton
            variant='ghost'
            style={{ cursor: 'pointer' }}
            radius='full'
            asChild
        >
            <Icon onClick={handleOnClick} width={'24'} height={'24'} />
        </IconButton>
    );
};
